import React from "react";
import { Pie, PieChart, Cell, ResponsiveContainer, Tooltip } from "recharts";
import chroma from "chroma-js";

const ChartPieDonut = ({ chartData = [] }) => {

  function generateAdvancedShades(baseColor, numberOfShades = 5) {
    const colors: string[] = [];
    const baseChroma = chroma(baseColor);

    // Generate lighter shades
    for (let i = 0; i < numberOfShades; i++) {
      const lightness = 0.2 + (i / (numberOfShades - 1)) * 0.6;
      colors.push(baseChroma.luminance(lightness).hex());
    }

    return colors;
  }
  const colors = generateAdvancedShades("#4979ec", chartData.length);
  (chartData || []).forEach((entry: any, index) => {
    entry["color"] = colors[index];
  });

  // Custom tooltip component
  interface CustomTooltipProps {
    active?: boolean;
    payload?: { payload: { category: string }; value: number }[];
  }

  const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="text-sm text-gray-600">
            {payload[0].payload.category}: {payload[0].value}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-full mx-auto">
      <div className="h-full flex flex-col">
        {/* Card Content */}
        <div className="mx-auto aspect-square h-full w-full">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Tooltip content={<CustomTooltip />} />
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={2}
                dataKey="total"
              >
                {chartData.map((entry: any, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default ChartPieDonut;
